import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/approvalApi';

const mk = (name, fn) => createAsyncThunk(name, async (a, { rejectWithValue }) => {
  try { return (await fn(a)).data.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message || 'Error'); }
});

export const fetchApprovals   = mk('approvals/fetchAll',  () => api.getAllApprovals());
export const respondApproval  = mk('approvals/respond',   ({ id, dto }) => api.respondToApproval(id, dto));

// Keep old ones for backward compat
export const fetchPendingApprovals = fetchApprovals;
export const approveRequest = mk('approvals/approve', ({ id, comment }) => api.respondToApproval(id, { status: 'Approve', responseComment: comment }));
export const rejectRequest  = mk('approvals/reject',  ({ id, comment }) => api.respondToApproval(id, { status: 'Reject',  responseComment: comment }));

const slice = createSlice({
  name: 'approvals',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: b => {
    b.addCase(fetchApprovals.pending,   s => { s.loading = true; s.error = null; })
     .addCase(fetchApprovals.fulfilled, (s, { payload }) => { s.loading = false; s.list = payload || []; })
     .addCase(fetchApprovals.rejected,  (s, { payload }) => { s.loading = false; s.error = payload; });
    b.addCase(respondApproval.fulfilled, (s, { payload }) => {
      s.list = s.list.map(a => a.id === payload?.id ? payload : a);
    });
  },
});
export default slice.reducer;
